import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Configure Monaco worker location to avoid worker fetch errors
const monacoBase = `assets/monaco/min/`;
(window as any).MonacoEnvironment = {
  baseUrl: monacoBase,
  getWorkerUrl: () => `${monacoBase}vs/base/worker/workerMain.js`
};

if (environment.production)
{
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));
